module.exports = __webpack_public_path__ + "img/notification.39289a6f.svg";